module.exports = __webpack_public_path__ + "img/3.a4c1268.webp";